/* eslint-disable prettier/prettier */
import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  paper: {
    position: 'absolute',
    display: 'flex',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  }
}))
